import React, { useState, useContext } from 'react'
import {
	completeUserUpdate,
	completeUserUpdateErrors,
} from 'selfServicePortal/services/CustomerServices/updateUserService'
import { useTranslation } from 'react-i18next'
import { OtpInput } from 'selfServicePortal/components/OtpInput/OtpInput'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { useMutation } from '@tanstack/react-query'
import { getErrorMessage, isAxiosError } from 'selfServicePortal/utils'
import { Heading } from 'selfServicePortal/components'
import { ContactOtpLength } from '../MyAccount'

interface EmailOtpProps {
	sessionId: string | undefined
	onSuccess: () => void
}

export function EmailOtp({ onSuccess, sessionId }: EmailOtpProps) {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const [otp, setOtp] = useState('')
	const completeUserUpdateMutation = useMutation(
		() =>
			completeUserUpdate({
				customerId: customerData?.customerId,
				sessionId,
				otpCode: otp,
			}),
		{
			onSuccess: onSuccess,
		},
	)

	return (
		<>
			<Heading
				title={t('<Title Here>')}
				description={t('<Desctiption Here>')}
			/>

			<OtpInput value={otp} onChange={setOtp} />

			{completeUserUpdateMutation.isError && (
				<div className="error">
					{isAxiosError(completeUserUpdateMutation.error)
						? completeUserUpdateErrors[
								completeUserUpdateMutation.error.response?.data
									.message
						  ]
						: getErrorMessage(completeUserUpdateMutation.error)}
				</div>
			)}

			<div>
				<button
					type="button"
					className="btn btn-primary"
					disabled={otp.length !== ContactOtpLength}
					onClick={() => completeUserUpdateMutation.mutate()}>
					{t('Save')}
				</button>
			</div>
		</>
	)
}
